var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { "data-component": "app-launcher-update" } }, [
    _c("span", { staticClass: "title" }, [
      _vm._v("\n    " + _vm._s(_vm.title) + "\n  "),
    ]),
    _vm._v(" "),
    _c("span", { staticClass: "description" }, [
      _vm._v(
        "\n    " +
          _vm._s(_vm.$t("HITL.app-launcher.update-progress-description")) +
          "\n  "
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "progress" }, [
      _c("div", { staticClass: "progress-bar-container" }, [
        _c("div", { staticClass: "progress-bar", style: _vm.mProgressStyle }),
      ]),
      _vm._v(" "),
      _c("span", {
        staticClass: "progress-percent",
        domProps: { innerHTML: _vm._s(_vm.mProgressLabel) },
      }),
      _vm._v(" "),
      _c("span", { staticClass: "progress-items" }, [
        _vm._v("\n      " + _vm._s(_vm.activeMigrationId) + "\n    "),
      ]),
    ]),
    _vm._v(" "),
    _vm.showItemsProgress
      ? _c("div", { staticClass: "progress" }, [
          _c("div", { staticClass: "progress-bar-container" }, [
            _c("div", {
              staticClass: "progress-bar",
              style: _vm.iProgressStyle,
            }),
          ]),
          _vm._v(" "),
          _c("span", {
            staticClass: "progress-percent",
            domProps: { innerHTML: _vm._s(_vm.iProgressLabel) },
          }),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }